import UpdateDocsPage from './UpdateDocsPage';

export default UpdateDocsPage;


// WEBPACK FOOTER //
// ./src/components/UpdateDocs/index.jsx